import { IUserReputationBadgeRank } from 'src/modules/common/user/types';
export const getBadgeTitle = (() => {
    const titleMap = {
        [IUserReputationBadgeRank.BRONZE]: 'Bronze',
        [IUserReputationBadgeRank.SILVER]: 'Silver',
        [IUserReputationBadgeRank.GOLD]: 'Gold',
    };
    return (rank) => titleMap[rank];
})();
